"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
var core_1 = require("@emotion/core");
var styled_1 = __importDefault(require("@emotion/styled"));
var React = __importStar(require("react"));
var colors_1 = __importDefault(require("../tokens/colors"));
var fontSizes_1 = __importDefault(require("../tokens/fontSizes"));
var fontWeights_1 = __importDefault(require("../tokens/fontWeights"));
var lineHeights_1 = __importDefault(require("../tokens/lineHeights"));
var radii_1 = __importDefault(require("../tokens/radii"));
var spacing_1 = __importDefault(require("../tokens/spacing"));
var BaseInput = styled_1.default.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: auto;\n  width: 100%;\n  padding: ", " ", ";\n  border: 1px solid ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  line-height: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  box-sizing: border-box;\n\n  :disabled {\n    border-color: ", ";\n    color: ", ";\n  }\n\n  :disabled::placeholder {\n    color: ", ";\n    opacity: 1;\n  }\n\n  ::placeholder {\n    color: ", ";\n    opacity: 1;\n  }\n\n  &:focus {\n    outline: 2px solid ", ";\n    outline-offset: 2px;\n  }\n\n  ", "\n"], ["\n  height: auto;\n  width: 100%;\n  padding: ", " ", ";\n  border: 1px solid ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  line-height: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  box-sizing: border-box;\n\n  :disabled {\n    border-color: ", ";\n    color: ", ";\n  }\n\n  :disabled::placeholder {\n    color: ", ";\n    opacity: 1;\n  }\n\n  ::placeholder {\n    color: ", ";\n    opacity: 1;\n  }\n\n  &:focus {\n    outline: 2px solid ", ";\n    outline-offset: 2px;\n  }\n\n  ", "\n"])), spacing_1.default.space8, spacing_1.default.space16, colors_1.default.n90, colors_1.default.surface200, radii_1.default.field, lineHeights_1.default.lineheight24, fontSizes_1.default.fontsize16, fontWeights_1.default.regular, colors_1.default.n900, colors_1.default.n80, colors_1.default.n200, colors_1.default.n200, colors_1.default.n400, colors_1.default.borderPrimary, function (_a) {
    var error = _a.error;
    return (0, core_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    :hover:enabled {\n      border-color: ", ";\n    }\n    ", "\n  "], ["\n    :hover:enabled {\n      border-color: ", ";\n    }\n    ", "\n  "])), colors_1.default.n700, error === true &&
        "\n        border: 2px solid ".concat(colors_1.default.red500, ";\n        :not(:placeholder-shown) {\n          border-color: ").concat(colors_1.default.red500, ";\n        }\n      "));
});
exports.TextInput = React.forwardRef(function (props, ref) { return (React.createElement(BaseInput, __assign({ type: "text", placeholder: " " }, props, { ref: ref }))); });
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map